/// <amd-module name="VSSUI/PersonaCard" />
export * from "./Components/PersonaCard/index";
